import React, { PureComponent } from 'react';
import classNames from 'classnames';

import { BaseInputProps } from '../types';
import { Input } from 'antd';

export interface TextProps extends BaseInputProps {
  value?: string;

  onChange?(val?: string): void;

  /**
   * @default 'Text'
   * */
  placeholder?: string;

  inputWidth?: number;
}

function initState(props: TextProps) {
  return {
    preProps: props,
  };
}

export type TextState = ReturnType<typeof initState>;

export class Text extends PureComponent<TextProps, TextState> {
  static getDerivedStateFromProps(props: TextProps, state: TextState) {
    return { ...state, preProps: props };
  }

  state = initState(this.props);

  onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const $value = e.target.value;
    this.props.onChange?.($value);
  };

  onBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    this.props.onBlur?.();
  };

  render() {
    return (
      <div
        className={classNames(
          this.props.className,
        )}
        style={this.props.style}
      >
        {this.props.readonly ? (
          <span>{this.props.value || '-'}</span>
        ) : (
          <Input
            type="text"
            placeholder={this.props.placeholder || 'Text'}
            value={this.props.value || ''}
            onChange={this.onChange}
            onBlur={this.onBlur}
            autoComplete="off"
          />
        )}
      </div>
    );
  }
}
